import { defineComponent as d, openBlock as l, createElementBlock as t, mergeProps as m, unref as o, renderSlot as p, createElementVNode as e, createCommentVNode as u } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, A = { key: 2 }, f = { key: 3 }, M = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconKeyReturn"
}, w = /* @__PURE__ */ d({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: V, weight: n } = i(r);
    return (s, a) => (l(), t("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(V)), [
      p(s.$slots, "default"),
      o(n) === "bold" ? (l(), t("g", Z, a[0] || (a[0] = [
        e("path", { d: "M71.51,144.49a12,12,0,0,1,0-17l24-24a12,12,0,0,1,17,17L109,124h55V104a12,12,0,0,1,24,0v32a12,12,0,0,1-12,12H109l3.52,3.51a12,12,0,0,1-17,17ZM236,56V200a20,20,0,0,1-20,20H40a20,20,0,0,1-20-20V56A20,20,0,0,1,40,36H216A20,20,0,0,1,236,56Zm-24,4H44V196H212Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (l(), t("g", g, a[1] || (a[1] = [
        e("path", {
          d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M184,104v32a8,8,0,0,1-8,8H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,128H168V104a8,8,0,0,1,16,0Zm48-48V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Z" }, null, -1)
      ]))) : o(n) === "fill" ? (l(), t("g", A, a[2] || (a[2] = [
        e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-32,96a8,8,0,0,1-8,8H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,128H168V104a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : o(n) === "light" ? (l(), t("g", f, a[3] || (a[3] = [
        e("path", { d: "M182,104v32a6,6,0,0,1-6,6H94.48l13.76,13.76a6,6,0,1,1-8.48,8.48l-24-24a6,6,0,0,1,0-8.48l24-24a6,6,0,0,1,8.48,8.48L94.48,130H170V104a6,6,0,0,1,12,0Zm48-48V200a14,14,0,0,1-14,14H40a14,14,0,0,1-14-14V56A14,14,0,0,1,40,42H216A14,14,0,0,1,230,56Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V200a2,2,0,0,0,2,2H216a2,2,0,0,0,2-2Z" }, null, -1)
      ]))) : o(n) === "regular" ? (l(), t("g", M, a[4] || (a[4] = [
        e("path", { d: "M184,104v32a8,8,0,0,1-8,8H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,128H168V104a8,8,0,0,1,16,0Zm48-48V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Z" }, null, -1)
      ]))) : o(n) === "thin" ? (l(), t("g", h, a[5] || (a[5] = [
        e("path", { d: "M180,104v32a4,4,0,0,1-4,4H89.66l17.17,17.17a4,4,0,0,1-5.66,5.66l-24-24a4,4,0,0,1,0-5.66l24-24a4,4,0,0,1,5.66,5.66L89.66,132H172V104a4,4,0,0,1,8,0Zm48-48V200a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V56A12,12,0,0,1,40,44H216A12,12,0,0,1,228,56Zm-8,0a4,4,0,0,0-4-4H40a4,4,0,0,0-4,4V200a4,4,0,0,0,4,4H216a4,4,0,0,0,4-4Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  w as default
};
